/* global __CLIENT__*/
import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import { ProjectActions } from '../actions/project';
import { ModalActions } from '../actions/modal';
import Loading from './Loading';

import '../styles/IconSelect.css';

class IconSelect extends Component {
  static propTypes = {
  };

  state = {
    limit: 80
  }

  setIcon(iconId) {
    const { dispatch, currentProjectId, componentType, componentId } = this.props;

    dispatch(ProjectActions.setIcon(currentProjectId, componentType, componentId, iconId));

    dispatch(ProjectActions.clearIconSearch());

    dispatch(ModalActions.hideModal());
  }

  loadMore() {
    this.setState({ limit: this.state.limit + 80 });
  }

  debouceFunction = debounce(function (e) {
    const { fields: { input }, dispatch, currentProjectId } = this.props;

    if (input && input.length > 2) {
      dispatch(ProjectActions.iconSearch(currentProjectId, input, this.state.limit));
    } else {
      dispatch(ProjectActions.clearIconSearch());
    }
  }, 1000, {
    trailing: true,
    leading: false
  })

  onChange(e) {
    this.debouceFunction(e);
  }

  onSubmit(e) {
    e.preventDefault();
  }

  renderIcons() {
    const { icons, iconsSearch, iconsSearchLoading, iconsSearchLoaded } = this.props;

    const dataSet = iconsSearch.size > 0 ? iconsSearch : !iconsSearchLoading && iconsSearchLoaded ? [] : icons;

    let output = [];

    if (icons.size > 0) {
      if (dataSet.length === 0) {
        return <div style={{fontWeight: "bold", margin: "0px auto"}}>No results found. Try entering a different search term.</div>;
      }

      let slicedDataSet = dataSet.slice(0, this.state.limit);

      slicedDataSet.forEach((v, k) => {
        let svgSrc = '/icons/' + v.get('name') + '.svg';
        // let svg = require(svgSrc);

        output.push(<div className="col-sm-3 iconselect-hover" key={k} onClick={::this.setIcon.bind(this, k)} >
          <img alt="" className="iconselect-select-icon" src={svgSrc} />
          <span>{v.get('name')}</span>
        </div>);
      }, this);
    }

    return output;
  }

  render() {
    const { icons, iconsSearch, iconsSearchLoading, iconsSearchLoaded, componentType } = this.props;

    const dataSet = iconsSearch.size > 0 ? iconsSearch.size : icons.size;

    let loadMoreButton = (this.state.limit < dataSet) ? <button style={{ margin: '20px auto', display: 'block', width: '50%' }} className="btn btn-primary" type="button" onClick={::this.loadMore}>Load More...</button> :
      <span />;

    if (!iconsSearchLoading && iconsSearchLoaded && iconsSearch.size === 0) {
      loadMoreButton = <span />
    }

    const searchLoadingState = iconsSearchLoading ? <Loading loadingMessage="Searching for Icons..." offset="true" /> : null;

    let defaultElement;

    switch (componentType) {
      case 'elements':
        defaultElement = 'icomoon icon-element';
        break;
      case 'elementTypes':
        defaultElement = 'icomoon icon-element-type';
        break;
      case 'relationshipTypes':
        defaultElement = 'icomoon icon-rel-type';
        break;
      case 'relationships':
        defaultElement = 'icomoon icon-rel-type';
        break;
      case 'views':
        defaultElement = 'icomoon icon-views';
        break;
      default:
        break;
    }

    return (<div>
      <button onClick={::this.setIcon.bind(this, null)} className="btn btn-success" style={{ float: 'right' }}>Reset to Default Icon <i style={{ fontSize: 25, top: 4, position: 'relative' }} className={defaultElement}></i></button>
      <form onChange={::this.onChange} onSubmit={::this.onSubmit} className="row">
        <div className="col-md-12">
          <fieldset>
            <div style={{ position: 'relative', color: '#aaa', fontSize: 16 }}>
              <span className="fa fa-search" style={{ position: 'absolute', top: 10, right: 10 }}></span>
              <Field component="input" name="input" type="text" className="form-control" placeholder="Begin typing to search for icons." autoFocus="true" />
            </div>
          </fieldset>
        </div>
      </form>
      {searchLoadingState}
      <div className="row">
        {::this.renderIcons()}
      </div>
      {loadMoreButton}
    </div>);
  }
}

const currentProjectIdSelector = (state, props) => {
  return state.projects.get('currentProjectId');
};

const iconsSelector = (state, props) => {
  return state.icons.getIn(['icons']);
};

const iconsSearchSelector = (state, props) => {
  return state.icons.getIn(['search']);
};

const iconsSearchLoadingSelector = (state, props) => {
  return state.icons.getIn(['searchLoading']);
};

const iconsSearchLoadedSelector = (state, props) => {
  return state.icons.getIn(['searchLoaded']);
};

const elementFormSelector = (state) => {
  const selector = formValueSelector('iconSelect');
  return selector(state, 'input');
};

const IconSelectSelector = immutableCreatorSelector(
  [currentProjectIdSelector, iconsSearchLoadingSelector, iconsSelector, iconsSearchSelector, elementFormSelector, iconsSearchLoadedSelector],
  (currentProjectId, iconsSearchLoading, icons, iconsSearch, elementForm, iconsSearchLoaded) => {
    return {
      iconsSearchLoading,
      iconsSearchLoaded,
      currentProjectId,
      icons,
      iconsSearch,
      fields: {
        input: elementForm
      }
    };
  }
);

@reduxForm({
  form: 'iconSelect',
  destroyOnUnmount: false
}, (_state) => ({
  initialValues: {
    input: ''
  }
}))
@connect(IconSelectSelector)
export default class IconSelectContainer extends Component {
  static propTypes = {
  };

  render() {
    return <IconSelect {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/IconSelect.js